import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgxRolesService } from 'ngx-permissions';
import { AuthService } from '../../../services/auth.service';
import { PNotifyService } from '../../../services/pnotify.service';
import { Select2OptionData } from 'ng2-select2';

@Component({
  selector: 'app-bus-swap',
  templateUrl: './bus-swap.component.html',
  styleUrls: ['./bus-swap.component.css']
})
export class BusSwapComponent implements OnInit {

  // Step management
  step: number = 1; // 1=Select, 2=Preview, 3=Done

  // Client / School selection
  clientId: string = '';
  schoolId: string = '';
  clients: any[] = [];
  schools: any[] = [];
  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;

  // Bus selection
  buses: any[] = [];
  busAId: string = '';
  busBId: string = '';
  public busAData: Array<Select2OptionData>;
  public busBData: Array<Select2OptionData>;

  // Preview
  preview: any = null;
  loading: boolean = false;
  errorMsg: string = '';

  // Result
  resultMsg: string = '';

  pnotify: any;

  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private roleService: NgxRolesService,
    pnotifyService: PNotifyService
  ) {
    this.pnotify = pnotifyService.getPNotify();
  }

  ngOnInit() {
    this.initClientSelect();
  }

  // ========== Client / School / Bus Selectors ==========

  initClientSelect() {
    this.http.get('/api/client/lookup').subscribe((clients: any[]) => {
      this.clients = clients;
      const array1 = [{ id: '', text: 'Choisir un client' }];
      const array2 = this.clients.map(c => ({ id: c.id, text: c.name }));
      this.clientsData = array1.concat(array2);
    });
  }

  clientChanged(e: any) {
    this.clientId = e.value;
    this.schoolId = '';
    this.buses = [];
    this.busAId = '';
    this.busBId = '';
    this.preview = null;
    this.initSchoolSelect();
  }

  initSchoolSelect() {
    let params = new HttpParams({ fromObject: { clientId: this.clientId } });
    this.http.get('/api/school/lookup', { params }).subscribe((schools: any[]) => {
      this.schools = schools;
      const array1 = [{ id: '', text: 'Choisir un établissement' }];
      const array2 = this.schools.map(s => ({ id: s.id, text: s.name }));
      this.schoolsData = array1.concat(array2);
    });
  }

  schoolChanged(e: any) {
    this.schoolId = e.value;
    this.buses = [];
    this.busAId = '';
    this.busBId = '';
    this.preview = null;
    if (this.schoolId) {
      this.loadBuses();
    }
  }

  loadBuses() {
    let params = new HttpParams({ fromObject: { clientId: this.clientId, schoolId: this.schoolId } });
    this.http.get('/api/bus/lookup', { params }).subscribe((buses: any[]) => {
      this.buses = buses;
      const array1 = [{ id: '', text: 'Choisir un véhicule' }];
      const array2 = this.buses.map(b => ({ id: b.id, text: b.name + (b.driverName ? ' — ' + b.driverName : '') }));
      this.busAData = array1.concat(array2);
      this.busBData = array1.concat(array2);
    });
  }

  busAChanged(e: any) {
    this.busAId = e.value;
    this.preview = null;
  }

  busBChanged(e: any) {
    this.busBId = e.value;
    this.preview = null;
  }

  // ========== Step navigation ==========

  get canPreview(): boolean {
    return !!(this.clientId && this.schoolId && this.busAId && this.busBId && this.busAId !== this.busBId);
  }

  goPreview() {
    if (!this.canPreview) return;
    this.loading = true;
    this.errorMsg = '';
    this.http.post('/api/bus/swap-preview', {
      busAId: this.busAId,
      busBId: this.busBId
    }).subscribe(
      (result: any) => {
        this.preview = result;
        this.step = 2;
        this.loading = false;
      },
      (err: any) => {
        this.errorMsg = (err.error && err.error.message) || 'Erreur lors de la prévisualisation.';
        this.loading = false;
      }
    );
  }

  goBack() {
    this.step = 1;
    this.preview = null;
  }

  applySwap() {
    this.loading = true;
    this.errorMsg = '';
    this.http.post('/api/bus/swap-apply', {
      busAId: this.busAId,
      busBId: this.busBId
    }).subscribe(
      (result: any) => {
        this.loading = false;
        this.step = 3;
        this.resultMsg = result.message || 'Permutation effectuée avec succès.';
        this.pnotify.success({ text: this.resultMsg });
      },
      (err: any) => {
        this.loading = false;
        this.errorMsg = (err.error && err.error.message) || 'Erreur lors de la permutation.';
        this.pnotify.error({ text: this.errorMsg });
      }
    );
  }

  reset() {
    this.step = 1;
    this.busAId = '';
    this.busBId = '';
    this.preview = null;
    this.resultMsg = '';
    this.errorMsg = '';
    if (this.schoolId) {
      this.loadBuses();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/bus/bus-swap/bus-swap.component.ts